import { cn } from '@/lib/cn';
import { initialsOf } from '@/lib/format';

export interface AvatarProps {
  name: string;
  size?: 'sm' | 'md';
  className?: string;
}

/** Initials badge. No image support yet - there is nowhere to upload one. */
export function Avatar({ name, size = 'md', className }: AvatarProps) {
  return (
    <span
      aria-hidden="true"
      title={name}
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full bg-primary font-semibold text-primary-content',
        size === 'sm' ? 'h-5 w-5 text-2xs' : 'h-6 w-6 text-2xs',
        className,
      )}
    >
      {initialsOf(name)}
    </span>
  );
}
